module.exports = __webpack_public_path__ + "static/media/Q6-2.a42dfd80.jpg";